<template>
    <div class="item-panel" @click="show_detail(p_product.id)">
        <van-row>
            <van-col span="8">
                <div class="item-img">
                    <img :src="p_product.thumb" />
                </div>
            </van-col>
            <van-col span="16">
                <div class="item-content">
                    <div class="title">{{p_product.name}}</div>
                    <van-row type="flex" justify="space-between">
                        <van-col span="12">
                            <div class="bottom-panel">
                                <div>
                                    <span class="price-code">￥</span>
                                    <span class="price">{{p_product.price}}</span>
                                    <span class="price-origin-code">￥</span>
                                    <span class="price-origin">{{p_product.origin_price}}</span>
                                </div>
                                <div class="commission" v-if="mode==2">
                                    <span class="label">佣金</span>
                                    <span class="value">￥{{p_product.commission}}</span>
                                </div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="bottom-right" v-if="mode==2">
                                <van-button type="primary" size="small" v-if="p_product.pub_status==2" @click="show_detail(p_product.id)">获取海报</van-button>
                                <van-button type="default" size="small" v-if="p_product.pub_status==3">即将上市</van-button>
                                <van-button type="default" size="small" v-if="p_product.pub_status==4">已下线</van-button>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </van-col>
        </van-row>
    </div>
</template>

<script>
    import config from '@/config';

    export default {
        name: "ProductItem",
        props:{
            p_product:{
                type:Object,
                default:null,
                required:true,
            },
        },
        data(){
            return{
                moment:this.$moment,
                mode:config.mode,
                sales_uid:this.$store.getters.getMySalesId.toString(),
            }
        },
        methods:{
            show_detail(val){
                if(this.p_product.pub_status==2){
                    if(this.mode==1){
                        let sales_uid=this.sales_uid;
                        this.$router.push({ name: 'ProductDetailSale',params: {product_id:val,sales_uid}});
                    }else{
                        this.$router.push({ name: 'ProductDetail',params: {product_id:val}});
                    }
                }
            },
        },
        mounted() {
            // console.log('mode',this.mode);
            // console.log('参数',this.p_product);
        }
    }
</script>

<style lang="scss" scoped>
    .item-panel{
        padding-top: 10px;
    }
    .item-img{
        font-size:0;
        img {
            width: 120px;
            height: 120px;
        }
    }
    .item-content{
        position: relative;
        text-align: left;
        padding-left: 0;
        min-height: 122px;
        .title{
            padding-right: 2px;
            font-size: 14px;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .bottom-right{
            position: absolute;
            bottom: 0;
        }
        .bottom-panel{
            position: absolute;
            bottom: 0;
            width: 80%;
        }
        .price-code{
            font-size: 12px;
            color: #E34928;
        }
        .price{
            font-size: 16px;
            font-weight: bold;
            color: #E34928;
        }
        .price-origin-code{
            padding-left: 5px;
            font-size: 12px;
            color: #666666;
        }
        .price-origin{
            font-size: 12px;
            text-decoration:line-through;
            color: #666666;
        }
        .commission{
            border: 1px solid #E34928;
            border-radius: 3px;
            font-size: 12px;
            width: 80px;
            text-align: center;
            .label{
                display: inline-block;
                color: #E34928;
                width: 35px;
            }
            .value{
                display: inline-block;
                background-color: #E34928;
                color: #ffffff;
                font-weight: bold;
                width: 45px;

            }
        }

    }
</style>